import { getVoiceAssessmentSessionDefinitionIds } from '@/src/config/voice-assessment-session'
import { useSuspenseQuery } from '@tanstack/react-query'

import { appQueryOptions } from '../queries/view-queries'
import { useContentfulLocale } from './useContentfulLocale'

export function useAppSessionDefinitionIds(): number[] {
  const contentfulLanguage = useContentfulLocale()
  const { data } = useSuspenseQuery({
    ...appQueryOptions(contentfulLanguage),
    select: getVoiceAssessmentSessionDefinitionIds,
  })

  return data
}
